export default __webpack_public_path__ + "static/media/upload-button.79d096f0.svg";